class HttpUploadError extends Error {
  constructor(resp) {
    super(resp.data.code);
    this.data = resp.data;
    this.message = resp.data.code;
  }
}

export default HttpUploadError;
